import { useParams } from "react-router-dom";
import AddEventNew from "./addEventNew";

const AddEventWrapper = () => {
    const { id } = useParams();
    return <AddEventNew key={id ?? 'new'} />;
};

export default AddEventWrapper;